var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnPlayerReportWithTitle = function SvgIcnPlayerReportWithTitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9331 10.2814V19.9501C21.9331 22.9251 20.158 23.9168 17.9664 23.9168H10.0331C7.84149 23.9168 6.06641 22.9251 6.06641 19.9501V10.2814C6.06641 7.05845 7.84149 6.3147 10.0331 6.3147C10.0331 6.92953 10.281 7.48486 10.6875 7.89144C11.0941 8.29803 11.6495 8.54595 12.2643 8.54595H15.7352C16.9648 8.54595 17.9664 7.54436 17.9664 6.3147C20.158 6.3147 21.9331 7.05845 21.9331 10.2814Z",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.967 6.31475C17.967 7.54441 16.9654 8.546 15.7358 8.546H12.2649C11.6501 8.546 11.0947 8.29808 10.6882 7.89149C10.2816 7.48491 10.0337 6.92958 10.0337 6.31475C10.0337 5.08508 11.0353 4.0835 12.2649 4.0835H15.7358C16.3506 4.0835 16.906 4.33142 17.3126 4.738C17.7191 5.14458 17.967 5.69991 17.967 6.31475Z",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0337 14.9917H14.0004",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0337 18.9585H17.967",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPlayerReportWithTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_player_report_with_title.f6105f0b.svg";
export { ForwardRef as ReactComponent };